import { cloudflareImageLoader } from './image';

export default function nextImageLoader({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}): string {
  return cloudflareImageLoader({
    src,
    width,
    quality: quality == null || quality === 75 ? 85 : quality,
  });
}
